// src/utils/NotifyingLocalStorage.ts
import {LocalStorage, SIWXStorage, SIWXSession} from "@reown/appkit-siwx";
import {CaipNetworkId} from "@reown/appkit";

export const STORAGE_EVENT = "siwx-storage";

export class NotifyingLocalStorage implements SIWXStorage {
  private inner: LocalStorage;

  constructor(opts: { key: string }) {
    this.inner = new LocalStorage(opts);
  }

  private notify(type: "add" | "delete" | "set") {
    window.dispatchEvent(new CustomEvent(STORAGE_EVENT, {detail: {type}}));
  }

  async add(session: SIWXSession): Promise<void> {
    await this.inner.add(session);
    this.notify("add");
  }

  async delete(chainId: CaipNetworkId, address: string): Promise<void> {
    await this.inner.delete(chainId, address);
    this.notify("delete");
  }

  async set(sessions: SIWXSession[]): Promise<void> {
    await this.inner.set(sessions);
    this.notify("set");
  }

  async get(chainId: CaipNetworkId, address: string): Promise<SIWXSession[]> {
    return this.inner.get(chainId, address);
  }
}
